import { memo } from 'react';

import { Flex } from '@mantine/core';

import { LoginForm } from '@/features/Auth/LoginForm.tsx';

const Unauthorized = () => (
	<Flex align="center" justify="center" h="100%" px="lg" w="100%">
		<LoginForm />
	</Flex>
);

export default memo(Unauthorized);
